module.exports = __webpack_public_path__ + "img/low-activity-reports.01d9d18e.png";